import React, { FC, memo, ReactElement, useContext } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { UserPresence, UserPresences } from '../Types/Types'
import { PresenceUserCard } from './PresenceUserCard'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { LanguageContext } from '../../Common/Contexts'
import { Presence } from '../../../../i18n'
import Loader from '../../Common/Components/Loader'

type Props = {
    presenceGroups: [string, UserPresences][]
    incrementPage: () => void
    isMorePagination: boolean
    isContentUpdating?: boolean
}

export const PresenceUsers: FC<Props> = memo(
    ({ presenceGroups, isMorePagination, incrementPage, isContentUpdating }: Props): ReactElement => {
        const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler

        return (
            <div className='tp-presence-users-display'>
                <div className='tp-presence-groups-container'>
                    {(presenceGroups?.length ?? 0) > 0 ? (
                        <InfiniteScroll
                            next={incrementPage}
                            hasMore={isMorePagination || !!isContentUpdating}
                            loader={<Loader className='pu-pagination-loader' />}
                            dataLength={presenceGroups.flatMap(([, users]: [string, UserPresences]) => users).length}
                        >
                            {presenceGroups.map(
                                ([key, users]: [string, UserPresences]): ReactElement => (
                                    <div className='tp-user-presence-group' key={key}>
                                        {presenceGroups.length > 1 ? (
                                            <h2 className='tp-presence-group-title'>
                                                {language.get(`Presence_Filter_Availability_${key}`)}
                                            </h2>
                                        ) : (
                                            <></>
                                        )}
                                        <div className='tp-presence-users'>
                                            {users.map(
                                                (user: UserPresence): ReactElement => (
                                                    <PresenceUserCard key={user.userID} user={user} />
                                                )
                                            )}
                                        </div>
                                    </div>
                                )
                            )}
                        </InfiniteScroll>
                    ) : (
                        <div className='tp-no-presences'>{language.get(Presence.Presence_NoUsers)}</div>
                    )}
                </div>
            </div>
        )
    }
)
